import { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const buttonPreset: ButtonDesignTokens = {
  colorScheme: {
    light: {
      root: {
        primary: {
          hoverBackground: 'transparent',

        }
      }
    }
  }
}
